import React, { useState } from 'react';
import { Button } from './Button';
import { Input } from './Input';
import { Textarea } from './Textarea';
import { Label } from './Label';
import { Checkbox } from './Checkbox';
import { Card, CardContent } from './Card';
export function ContactForm() {
  const [isPreviousCustomer, setIsPreviousCustomer] = useState<boolean | null>(null);
  return <section id="contact" className="py-20 bg-tx-light" data-id="element-26">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-tx-deep mb-4 tracking-tight" data-id="element-29">
            Request Your Free Inspection
          </h2>
          <p className="text-lg text-tx-body" data-id="element-30">
            Fill out the form below and our team will get back to you shortly to
            schedule your inspection.
          </p>
        </div>

        <Card className="border-0 shadow-xl rounded-2xl overflow-hidden" data-id="element-31">
          <CardContent className="p-8 md:p-12" data-id="element-32">
            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-33">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-34">
                <div className="space-y-2" data-id="element-35">
                  <Label htmlFor="name" className="text-tx-body font-semibold" data-id="element-36">
                    Name *
                  </Label>
                  <Input id="name" required className="h-12 bg-gray-50" data-id="element-37" />
                </div>
                <div className="space-y-2" data-id="element-38">
                  <Label htmlFor="email" className="text-tx-body font-semibold" data-id="element-39">
                    Email *
                  </Label>
                  <Input id="email" type="email" required className="h-12 bg-gray-50" data-id="element-40" />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-41">
                <div className="space-y-2" data-id="element-42">
                  <Label htmlFor="phone" className="text-tx-body font-semibold" data-id="element-43">
                    Phone *
                  </Label>
                  <Input id="phone" type="tel" required className="h-12 bg-gray-50" data-id="element-44" />
                </div>
                <div className="space-y-2" data-id="element-45">
                  <Label htmlFor="address" className="text-tx-body font-semibold" data-id="element-46">
                    Address
                  </Label>
                  <Input id="address" className="h-12 bg-gray-50" data-id="element-47" />
                </div>
              </div>

              <div className="space-y-3" data-id="element-48">
                <Label className="text-tx-body font-semibold" data-id="element-49">
                  Are you a previous customer?
                </Label>
                <div className="flex gap-4" data-id="element-50">
                  <label className="flex items-center gap-2 cursor-pointer" data-id="element-51">
                    <input type="radio" name="previousCustomer" className="w-4 h-4 text-tx-red focus:ring-tx-red" onChange={() => setIsPreviousCustomer(true)} data-id="element-52" />
                    <span data-id="element-53">Yes</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer" data-id="element-54">
                    <input type="radio" name="previousCustomer" className="w-4 h-4 text-tx-red focus:ring-tx-red" onChange={() => setIsPreviousCustomer(false)} data-id="element-55" />
                    <span data-id="element-56">No</span>
                  </label>
                </div>
              </div>

              <div className="space-y-2" data-id="element-57">
                <Label htmlFor="message" className="text-tx-body font-semibold" data-id="element-58">
                  Message / Comments *
                </Label>
                <Textarea id="message" required className="min-h-[120px] bg-gray-50 resize-y" data-id="element-59" />
              </div>

              <div className="space-y-4 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-60">
                <div className="flex items-start space-x-3" data-id="element-61">
                  <Checkbox id="consent-1" className="mt-1 data-[state=checked]:bg-tx-red data-[state=checked]:border-tx-red" data-id="element-62" />
                  <Label htmlFor="consent-1" className="text-sm text-gray-600 leading-relaxed font-normal cursor-pointer" data-id="element-63">
                    I agree to receive transactional and appointment-related
                    text messages from Texas Direct Roofing. Reply STOP to opt
                    out.
                  </Label>
                </div>
                <div className="flex items-start space-x-3" data-id="element-64">
                  <Checkbox id="consent-2" className="mt-1 data-[state=checked]:bg-tx-red data-[state=checked]:border-tx-red" data-id="element-65" />
                  <Label htmlFor="consent-2" className="text-sm text-gray-600 leading-relaxed font-normal cursor-pointer" data-id="element-66">
                    I agree to receive marketing and promotional text messages
                    from Texas Direct Roofing. Reply STOP to opt out. Message
                    and data rates may apply.
                  </Label>
                </div>
              </div>

              {/* Placeholder for Turnstile */}
              <div className="w-full h-[65px] bg-gray-100 rounded flex items-center justify-center text-sm text-gray-400 border border-dashed border-gray-300" data-id="element-67">
                Spam Protection Placeholder
              </div>

              <Button type="submit" className="w-full bg-tx-red hover:bg-tx-red/90 text-white font-bold h-14 rounded-lg text-lg" data-id="element-68">
                Send Message
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>;
}